import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";
import { LoadingFileArancelCompleto, LoadingFileArancelSeleccionado, Loading } from "../FiltroBusqueda/actions";
const download = require("downloadjs");
const axios = require("axios");

// //////////////////
// Action Creators //
// //////////////////

export const SetValidacionReplicacionSolicitud = (prestadorPuedeReplicar, usuarioPuedeReplicar) => ({
  type: "RA_SR/SET_VALIDACION_USUARIO",
  prestadorPuedeReplicar,
  usuarioPuedeReplicar,
});

export const ModalSolicitudReajustePaso = (paso) => ({
  type: "RA_SR/MODAL_SOLICITUD_REAJUSTE_PASOS",
  paso,
});

export const ModalAceptarOpen = (open) => ({
  type: "RA_SR/MODAL_ACEPTAR_OPEN",
  open,
});

export const CargarCombinacionesValidasSolicitudReajuste = (solicitudesReajuste) => ({
  type: "RA_SR/MODAL_SOLICITUD_REAJUSTE_CARGA_COMBINACION_VALIDA_SOLICITUD_REAJUSTE",
  solicitudesReajuste,
});

export const CargarCombinacionesSolicitudReajuste = () => ({
  type: "RA_SR/MODAL_SOLICITUD_REAJUSTE_CARGA_COMBINACION_SOLICITUD_REAJUSTE",
  global: store.getState().global,
});

export const CargarCombinacionesSolicitudReajustePQ = () => ({
  type: "RA_SR/MODAL_SOLICITUD_REAJUSTE_CARGA_COMBINACION_SOLICITUD_REAJUSTE_PAQUETES",
  global: store.getState().global,
});

export const ModalSolicitudReajusteLoading = (accionModalLoading) => ({
  type: "RA_SR/MODAL_SOLICITUD_REAJUSTE_LOADING",
  accionModalLoading,
});

export const ModalConsultarPeriodoReajuste = (accionModal) => ({
  type: "RA_SR/MODAL_CONSULTAR_PERIODO_REAJUSTE",
  accionModal,
});

export const CambiarComentario = (comentario) => ({
  type: "RA_SR/CAMBIAR_COMENTARIO",
  comentario,
});

export const CambiarComentarioPQ = (comentarioPQ) => ({
  type: "RA_SR/CAMBIAR_COMENTARIO_PQ",
  comentarioPQ,
});

export const CambiarValorReajuste = (valorReajuste) => ({
  type: "RA_SR/CAMBIAR_VALOR_REAJUSTE",
  valorReajuste,
});

export const CambiarValorReajustePQ = (valorReajustePaquetes) => ({
  type: "RA_SR/CAMBIAR_VALOR_REAJUSTE_PQ",
  valorReajustePaquetes,
});

export const CambiarValorReajusteMax = (valorReajusteMax) => ({
  type: "RA_SR/CAMBIAR_VALOR_REAJUSTE_MAX",
  valorReajusteMax,
});

export const CambiarValorReajusteMaxPQ = (valorReajusteMax) => ({
  type: "RA_SR/CAMBIAR_VALOR_REAJUSTE_MAX_PQ",
  valorReajusteMax,
});

export const CambiarValorReajusteError = (valorReajusteError) => ({
  type: "RA_SR/CAMBIAR_VALOR_REAJUSTE_ERROR",
  valorReajusteError,
});

export const CambiarValorReajusteErrorPQ = (valorReajustePaquetesError) => ({
  type: "RA_SR/CAMBIAR_VALOR_REAJUSTE_ERROR_PQ",
  valorReajustePaquetesError,
});

export const CambiarItemsEliminados = (eliminados) => ({
  type: "RA_SR/CAMBIAR_ITEMS_ELIMINADOS",
  eliminados,
});

export const CambiarCheckCentroAtencion = (isChecked, id) => ({
  type: "RA_SR/CAMBIAR_CHECK_CENTRO_ATENCION",
  isChecked,
  id,
});

export const CambiarCheckCentroAtencionPQ = (isChecked, id) => ({
  type: "RA_SR/CAMBIAR_CHECK_CENTRO_ATENCION_PQ",
  isChecked,
  id,
});

export const CambiarCheckCentroAtencionError = (checkCentrosAtencionError) => ({
  type: "RA_SR/CAMBIAR_CHECK_CENTRO_ATENCION_ERROR",
  checkCentrosAtencionError,
});

export const CambiarCheckCentroAtencionErrorPQ = (checkCentrosAtencionErrorPQ) => ({
  type: "RA_SR/CAMBIAR_CHECK_CENTRO_ATENCION_ERROR_PQ",
  checkCentrosAtencionErrorPQ,
});

export const CambiarVigenciasErrorPQ = (checkVigenciasErrorPQ) => ({
  type: "RA_SR/CAMBIAR_CHECK_VIGENCIAS_ERROR_PQ",
  checkVigenciasErrorPQ,
});


export const CambiarCheckTipoPrestacion = (isChecked, id) => ({
  type: "RA_SR/CAMBIAR_CHECK_TIPO_PRESTACION",
  isChecked,
  id,
});

export const CambiarCheckTipoPrestacionError = (checkTiposPrestacionError) => ({
  type: "RA_SR/CAMBIAR_CHECK_TIPO_PRESTACION_ERROR",
  checkTiposPrestacionError,
});

export const CambiarCheckArancel = (isChecked, id) => ({
  type: "RA_SR/CAMBIAR_CHECK_ARANCEL",
  isChecked,
  id,
});

export const CheckVigenciaPaquete = (isChecked, id) => ({
  type: "RA_SR/CAMBIAR_CHECK_VIGENCIA_PQ",
  isChecked,
  id,
});

export const CambiarCheckArancelError = (checkArancelesError) => ({
  type: "RA_SR/CAMBIAR_CHECK_ARANCEL_ERROR",
  checkArancelesError,
});

export const CambiarCheckVigenciaPaqueteError = (checkVigenciasErrorPQ) => ({
  type: "RA_SR/CAMBIAR_CHECK_VIGENCIAS_ERROR",
  checkVigenciasErrorPQ,
});

export const CheckCentroAtencionTodos = (isChecked, data) => ({
  type: "RA_SR/CAMBIAR_CHECK_CENTRO_ATENCION_TODOS",
  isChecked,
  data,
});

export const CheckCentroAtencionTodosPQ = (isChecked, data) => ({
  type: "RA_SR/CAMBIAR_CHECK_CENTRO_ATENCION_TODOS_PQ",
  isChecked,
  data,
});
export const CheckVigenciaPaqueteTodos = (isChecked, data) => ({
  type: "RA_SR/CAMBIAR_CHECK_VIGENCIA_PAQUETES_TODOS_PQ",
  isChecked,
  data,
});
export const CheckTipoPrestacionTodos = (isChecked, data) => ({
  type: "RA_SR/CAMBIAR_CHECK_TIPO_PRESTACION_TODOS",
  isChecked,
  data,
});

export const CheckArancelTodos = (isChecked, data) => ({
  type: "RA_SR/CAMBIAR_CHECK_ARANCEL_TODOS",
  isChecked,
  data,
});

export const ModalConfirmarSolicitarReajuste = (modalConfirmarSolicitud) => ({
  type: "RA_SR/MODAL_CONFIRMAR_SOLICITUD",
  modalConfirmarSolicitud,
});

export const CargarSolicitudCabeceraReajuste = (cabeceraSolicitud, esReplicacion) => ({
  type: "RA_SR/CARGAR_CABECERA_SOLICITUD",
  cabeceraSolicitud,
  esReplicacion,
});

export const CargarSolicitudCabeceraReajustePQ = (cabeceraSolicitud, esReplicacion) => ({
  type: "RA_SR/CARGAR_CABECERA_SOLICITUD_PQ",
  cabeceraSolicitud,
  esReplicacion,
});

export const SetDetalleValidacionCentrosAtencion = (secuencia, valido, secuenciaHomologo) => ({
  type: "RA_SR/SET_DETALLE_VALIDACION_CENTROS_ATENCION",
  secuencia,
  valido,
  secuenciaHomologo,
});

export const SetLoadingValidacionSolicitudEnCurso = (value) => ({
  type: "RA_SR/SET_VALIDACION_EN_CURSO",
  value,
});

export const SetLoadingValidacionCentrosAtencion = (value) => ({
  type: "RA_SR/SET_VALIDACION_CENTROS_ATENCION",
  value,
});

export const CambiarVigenciaReajuste = (vigenciaReajuste) => ({
  type: "RA_SR/CAMBIAR_VIGENCIA_REAJUSTE",
  vigenciaReajuste,
});

export const CambiarVigenciaReajustePQ = (vigenciaReajustePQ) => ({
  type: "RA_SR/CAMBIAR_VIGENCIA_REAJUSTE_PQ",
  vigenciaReajustePQ,
});

export const CambiarvigenciaReajusteError = (vigenciaReajusteError) => ({
  type: "RA_SR/VIGENCIA_REAJUSTE_ERROR",
  vigenciaReajusteError,
});

export const CambiarvigenciaReajustePQError = (vigenciaReajustePQError) => ({
  type: "RA_SR/VIGENCIA_REAJUSTE_ERROR",
  vigenciaReajustePQError,
});

export const CargarPaqueteVigencia = (vigencias) => ({
  type: "RA_SR/CARGAR_VIGENCIAS_PAQUETES",
  vigencias,
});

export const CambiarInicioReajusteError = (inicioReajusteError) => ({
  type: "RA_SR/INICIO_REAJUSTE_ERROR",
  inicioReajusteError,
});

export const CambiarInicioReajustePQError = (inicioReajustePQError) => ({
  type: "RA_SR/INICIO_REAJUSTE_PQ_ERROR",
  inicioReajustePQError,
});

export const CambiarReplicaPaquetes = (replicaPaquetes) => ({
  type: "RA_SR/CAMBIAR_REPLICA_PQ",
  replicaPaquetes,
});

export const CambiarReplicaPQError = (error) => ({
  type: "RA_SR/REPLICA_PQ_ERROR",
  error,
});

export const CambiarReplicaArancel = (replicaArancel) => ({
  type: "RA_SR/CAMBIAR_REPLICA_ARANCEL",
  replicaArancel,
});

export const CambiarReplicaArancelError = (error) => ({
  type: "RA_SR/REPLICA_ARANCEL_ERROR",
  error,
});


export const CargarSolicitudesEnCurso = (solicitudes) => ({
  type: "RA_SR/CARGAR_SOLICITUDES_EN_CURSO",
  solicitudes,
});

export const CargarSolicitudesEnCursoReplicaArancel = (solicitudes) => ({
  type: "RA_SR/CARGAR_SOLICITUDES_EN_CURSO_REP_A",
  solicitudes,
});

export const CargarVigenciasNoExistentesReplica = (vigencias) => ({
  type: "RA_SR/CARGAR_VIGENCIAS_NO_EXITENTES_REPLICA_PQ",
  vigencias,
});

export const LoadingValidacion = (loading) => ({
  type: "RA_SR/LOADING_VALIDACION",
  loading,
});

// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const DownloadArancelCompleto = () => (dispatch) => {
  const globalState = store.getState().global;
  var aranceles = [];
  var centros = [];

  globalState.filtros_CAT.tiposArancel.forEach(element => {
    aranceles.push(element.Rut);
  });

  globalState.filtros_CAT.centrosAtencion.forEach(element => {
    centros.push(element.Secuencia);
  });

  const params = {
    RutPrest: globalState.rutInstitucion,
    CentroMedico: centros,
    Arancel: aranceles,
    // Codinterno: globalState.filtros_CAT.codPrestacion,
    // Codfonasa: globalState.filtros_CAT.codFonasa,
    // Grupo: globalState.filtros_CAT.tipoPrestacion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/prestaciones/busquedaexcelcompleto/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
    timeout: 0
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      dispatch(LoadingFileArancelCompleto(false));
      sessionStorage.setItem('arancelCompleto', 1);
      download(blob, `ArancelCompleto_${globalState.rutInstitucion}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    })
    .catch((error) => {
      dispatch(LoadingFileArancelCompleto(false));
      trace.error("DownloadArancelCompleto", error);
      dispatch(ErrorSnacktOpen(
        "Error al descargar el arancel completo:",
        error,
      ));
    });
};

export const DownloadArancelSeleccionado = () => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutPrest: globalState.rutPrestador,
    CentroMedico: globalState.filtros_CAT.centroAtencion,
    Arancel: globalState.filtros_CAT.tipoArancel,
    Codinterno: globalState.filtros_CAT.codPrestacion,
    Codfonasa: globalState.filtros_CAT.codFonasa,
    Grupo: globalState.filtros_CAT.tipoPrestacion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/prestaciones/busquedaexcel/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      dispatch(LoadingFileArancelSeleccionado(false));
      download(blob, `ArancelSeleccionado_${globalState.rutInstitucion}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    })
    .catch((error) => {
      dispatch(LoadingFileArancelSeleccionado(false));
      trace.error("DownloadArancelSeleccionado", error);
      dispatch(ErrorSnacktOpen(
        "Error al descargar arancel seleccionado:",
        error,
      ));
    });
};

export const GetSolicitudesExcel = () => (dispatch) => {
  const globalState = store.getState().global;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Vigencia: 'S',
    FiltrosBusqueda: [],
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  axios.post(`${apiConfig.apiUri}/v1/paquetes/prestacionesExcel/`, { data: JSON.stringify(params) }, { responseType: "blob" })
    .then((response) => {
      if (response.status !== 200) {
        throw response.data;
      }
      //dispatch(LoadingExcel(false));
      sessionStorage.setItem('paquetesCompleto', 1);
      download(response.data, `paquetes_${(new Date()).toLocaleDateString()}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    }).catch((error) => {
      //dispatch(LoadingExcel(false));
      trace.error("GetSolicitudesExcel", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener el archivo de las prestaciones:",
        error,
      ));
    });
};

export const InsertReajuste = (esReplicacion, IdSolicitudPadre) => (dispatch) => {
  const globalState = store.getState().global;
  const solicitudReajusteState = store.getState().solicitudReajuste;
  const filtroBusquedaRAState = store.getState().filtroBusquedaRA;

  let idSolicitud = 0;
  let idSolicitudReplica = null;

  //console.log('solicitudReajusteState', solicitudReajusteState);

  //let idSolicitud = solicitudReajusteState.cabeceraSolicitud.IdSolicitud;
  const gruposReajuste = store.getState().solicitudReajuste.itemsSolicitudReajuste;
  if (esReplicacion) {
    idSolicitudReplica = solicitudReajusteState.cabeceraSolicitud.IdSolicitud;
  }

  const listSolicitudDetalle = [];
  gruposReajuste.forEach((gReajuste) => {
    let secuenciaG = gReajuste.secuencia;
    if (esReplicacion) {
      const secuenciaHomologa = solicitudReajusteState.detalleValidacionCentrosAtencion
        .filter((s) => s.secuencia === secuenciaG);
      secuenciaG = secuenciaHomologa && secuenciaHomologa.length > 0 ? secuenciaHomologa[0].secuenciaHomologo : null;
    }
    listSolicitudDetalle.push({
      IdSolicitud: idSolicitud,
      GrupoPrestacionIsapre: gReajuste.idTipoPrestacion,
      CentroAtencionSecuencia: secuenciaG,
      TipoAtencion: gReajuste.tipoAtencion,
      Arancel: gReajuste.rutArancel,
      ValorReajuste: parseFloat(solicitudReajusteState.valorReajuste.toString().replace(',', '.')),
      ComentarioPeriodoConsiderado: solicitudReajusteState.comentario || "",
      FechaVigencia: solicitudReajusteState.vigenciaReajuste,
      IdSolicitudReplica: idSolicitudReplica,
    });
  });

  //console.log('listSolicitudDetalle', listSolicitudDetalle)

  const params = {
    RutPrestador: globalState.rutPrestador,
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    Comentario: solicitudReajusteState.comentario || "Enviado desde Portal Prestadores",
    token: globalState.token,
    ListaUsuarios: globalState.listaUsuariosConvenio || 'SIN-ASIGNAR',
    usuarioMail: globalState.datosUsuario.mail,
    usuarioNombre: globalState.datosUsuario.nombre,
    RutUsuario: globalState.rutUsuario,
    listSolicitudDetalle,
  };
  if (esReplicacion) {
    params.Isapre = globalState.isapre === "B" ? "T" : "B";
  }
  fetch(`${apiConfig.apiUri}/v1/solicitudes/pushReajuste/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      //console.log('response', response)
      if (!response.ok) { throw new Error(response); }
      return response.json();
    })
    .then((json) => {
      //console.log('json', json)
      if (json) {
        //trace.information("InsertReajuste", json);
        dispatch(CargarSolicitudCabeceraReajuste(json[0], esReplicacion));
        if (solicitudReajusteState.replicaArancel === 1 && !esReplicacion) {
          dispatch(InsertReajuste(json[0], true));
        }
      } else {
        throw json;
      }
    })
    .catch((error) => {
      let errMessage = 'Consulte con el área de Soporte.';

      if (error.status === 500) {
        errMessage = 'Internal Server Error [500]: Verifique su conexión a internet y mande una fotografía de este error al área de Soporte.';
      }

      trace.error("InsertReajuste", error);
      dispatch(ErrorSnacktOpen(
        "Error al insertar solicitud de reajuste:",
        errMessage,
      ));
    });
};

export const InsertReajustePQ = (esReplicacion, IdSolicitudPadre) => (dispatch) => {
  const globalState = store.getState().global;
  const solicitudReajusteState = store.getState().solicitudReajuste;

  let idSolicitud = 0;
  let idSolicitudReplica = null;

  const gruposReajuste = store.getState().solicitudReajuste.itemsSolicitudReajustePQ;

  if (esReplicacion) {
    idSolicitudReplica = solicitudReajusteState.cabeceraSolicitud.IdSolicitudPQ;
  }

  const listSolicitudDetalle = [];
  gruposReajuste.forEach((gReajuste) => {
    listSolicitudDetalle.push({
      IdSolicitud: idSolicitud,
      Arancel: gReajuste.rutArancel,
      Vigencia: gReajuste.vigencias,
      ValorReajuste: parseFloat(solicitudReajusteState.valorReajustePaquetes.toString().replace(',', '.')),
      ComentarioPeriodoConsiderado: solicitudReajusteState.comentarioPQ || "",
      FechaVigencia: solicitudReajusteState.vigenciaReajustePQ,
      IdSolicitudReplica: idSolicitudReplica,
    });
  });

  //console.log('listSolicitudDetalle', listSolicitudDetalle)

  const params = {
    RutPrestador: globalState.rutPrestador,
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    Comentario: solicitudReajusteState.comentario || "Enviado desde Portal Prestadores",
    token: globalState.token,
    ListaUsuarios: globalState.listaUsuariosConvenio || 'SIN-ASIGNAR',
    usuarioMail: globalState.datosUsuario.mail,
    usuarioNombre: globalState.datosUsuario.nombre,
    RutUsuario: globalState.rutUsuario,
    listSolicitudDetalle,
  };
  if (esReplicacion) {
    params.Isapre = globalState.isapre === "B" ? "T" : "B";
  }
  fetch(`${apiConfig.apiUri}/v1/solicitudes/pushReajustePQ/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      //console.log('response', response)
      if (!response.ok) { throw new Error(response); }
      return response.json();
    })
    .then((json) => {
      //console.log('json', json)
      if (json) {
        //trace.information("InsertReajuste", json);
        dispatch(CargarSolicitudCabeceraReajustePQ(json[0], esReplicacion));
        if (solicitudReajusteState.replicaPaquetes === 1 && !esReplicacion) {
          dispatch(InsertReajustePQ(json[0], true));
        }
      } else {
        throw json;
      }
    })
    .catch((error) => {
      let errMessage = 'Consulte con el área de Soporte.';

      if (error.status === 500) {
        errMessage = 'Internal Server Error [500]: Verifique su conexión a internet y mande una fotografía de este error al área de Soporte.';
      }

      trace.error("InsertReajustePQ", error);
      dispatch(ErrorSnacktOpen(
        "Error al insertar solicitud de reajuste de paquetes:",
        errMessage,
      ));
    });
};

export const InsertSolicitudReajuste = (esReplicacion) => (dispatch) => {
  const globalState = store.getState().global;
  const solicitudReajusteState = store.getState().solicitudReajuste;

  const params = {
    RutPrestador: globalState.rutPrestador,
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    Comentario: solicitudReajusteState.comentario || "Enviado desde Portal Prestadores",
    token: globalState.token,
    ListaUsuarios: globalState.listaUsuariosConvenio,
    usuarioMail: globalState.datosUsuario.mail,
    usuarioNombre: globalState.datosUsuario.nombre,
    RutUsuario: globalState.rutUsuario,
  };
  if (esReplicacion) {
    params.Isapre = globalState.isapre === "B" ? "T" : "B";
  }
  fetch(`${apiConfig.apiUri}/v1/solicitudes/pushSolicitudReajuste/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (json) {
        //trace.information("InsertSolicitudReajuste", json);
        dispatch(CargarSolicitudCabeceraReajuste(json[0], esReplicacion));
        dispatch(InsertSolicitudReajusteDetalle(esReplicacion));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("InsertSolicitudReajuste", error);
      dispatch(ErrorSnacktOpen(
        "Error al insertar solicitud de reajuste:",
        error,
      ));
    });
};

export const InsertSolicitudReajusteDetalle = (esReplicacion) => (dispatch) => {
  const globalState = store.getState().global;
  const solicitudReajusteState = store.getState().solicitudReajuste;
  const filtroBusquedaRAState = store.getState().filtroBusquedaRA;

  let idSolicitud = solicitudReajusteState.cabeceraSolicitud.IdSolicitud;
  const gruposReajuste = store.getState().solicitudReajuste.itemsSolicitudReajuste;
  if (esReplicacion) {
    idSolicitud = solicitudReajusteState.cabeceraSolicitud.IdSolicitudReplicada;
  }

  const listSolicitudDetalle = [];
  gruposReajuste.forEach((gReajuste) => {
    let secuenciaG = gReajuste.secuencia;
    if (esReplicacion) {
      const secuenciaHomologa = solicitudReajusteState.detalleValidacionCentrosAtencion
        .filter((s) => s.secuencia === secuenciaG);
      secuenciaG = secuenciaHomologa && secuenciaHomologa.length > 0 ? secuenciaHomologa[0].secuenciaHomologo : null;
    }
    listSolicitudDetalle.push({
      IdSolicitud: idSolicitud,
      GrupoPrestacionIsapre: gReajuste.idTipoPrestacion,
      CentroAtencionSecuencia: secuenciaG,
      TipoAtencion: gReajuste.tipoAtencion,
      Arancel: gReajuste.rutArancel,
      ValorReajuste: solicitudReajusteState.valorReajuste,
      ComentarioPeriodoConsiderado: solicitudReajusteState.comentario || "",
      FechaVigencia: filtroBusquedaRAState.periodoReajuste.FechaVigencia,
    });
  });

  const params = {
    listSolicitudDetalle,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/solicitudes/pushDetalleReajuste/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (json) {
        //trace.information("InsertSolicitudReajusteDetalle", json);
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("InsertSolicitudReajusteDetalle", error);
      dispatch(ErrorSnacktOpen(
        "Error al insertar detalle de la solicitud de reajuste:",
        error,
      ));
    });
};

export const CargaCombinacionesReajuste = (itemsSolicitudReajuste) => (dispatch) => {
  const filtroBusquedaRAState = store.getState().global.filtros_CAT.centrosAtencion.slice();
  const centroAtencionConAranceles = [];
  // cargar por cada centro de atencion...
  let contador = filtroBusquedaRAState.length;
  filtroBusquedaRAState.forEach((filtro) => {
    const globalState = store.getState().global;
    const centroAtencion = filtro.Secuencia;
    // centroAtencion = null : Obtiene todos los tipos de arancel del prestador
    if (centroAtencion === null) {
      return;
    }
    const params = {
      RutInstitucion: globalState.rutInstitucion,
      CentroAtencion: centroAtencion,
      Isapre: globalState.isapre,
      token: globalState.token,
    };
    fetch(`${apiConfig.apiUri}/v1/aranceles/prestadorcongrupos/`, {
      method: "POST",
      headers: {
        // "Content-Type": "application/json",
        // Authorization: localStorage.getItem('id_token'),
      },
      credentials: "same-origin",
      body: JSON.stringify(params),
    })
      .then((response) => {
        if (!response.ok) { throw response; }
        return response.json();
      })
      .then((json) => {
        if (Array.isArray(json)) {
          //trace.information("ObtenerTiposArancel", json);
          centroAtencionConAranceles.push({
            Descripcion: filtro.Descripcion,
            Secuencia: filtro.Secuencia,
            Aranceles: json,
          });
          contador -= 1;
          if (contador === 0) {
            dispatch(ValidaCargaCombinacionesReajuste(itemsSolicitudReajuste, centroAtencionConAranceles));
          }
        } else {
          throw json;
        }
      })
      .catch((error) => {
        trace.error("ObtenerTiposArancel", error);
        dispatch(ErrorSnacktOpen(
          "Error al cargar combinaciones de reajuste:",
          error,
        ));
      });
  });
};

export const ValidaCargaCombinacionesReajuste = (itemsSolicitudReajuste, centroAtencionConAranceles) => (dispatch) => {
  const itemsSolicitudFiltrada = [];
  centroAtencionConAranceles.forEach((centro) => {
    centro.Aranceles.forEach((arancel) => {
      arancel.Grupos.forEach((grupo) => {
        const itemvalido = itemsSolicitudReajuste.filter((item) => item.key === `${centro.Secuencia}_${arancel.Rut}_${grupo.Id}`);
        if (itemvalido && itemvalido[0]) {
          itemsSolicitudFiltrada.push(itemvalido[0]);
        }
      });
    });
  });

  dispatch(CargarCombinacionesValidasSolicitudReajuste(itemsSolicitudFiltrada));
  dispatch(CambiarItemsEliminados(itemsSolicitudReajuste.length - itemsSolicitudFiltrada.length));
  dispatch(ModalAceptarOpen(true));
};

export const ValidarGruposSolicitudEnCurso = (callbackSuccess, callbackError) => (dispatch) => {
  const globalState = store.getState().global;
  const gruposReajuste = store.getState().solicitudReajuste.itemsSolicitudReajuste;
  const reajustePQ = store.getState().solicitudReajuste.itemsSolicitudReajustePQ;

  //dispatch(LoadingValidacion(true));

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    Prestaciones: [],
    token: globalState.token,
  };
  for (let i = 0; i < gruposReajuste.length; i += 1) {
    params.Prestaciones.push({
      Grupo: gruposReajuste[i].idTipoPrestacion,
      // CodPrestacion: grillaSolicitudState.prestacionesSolicitud[i].COD_PRESTADOR,
      // CofProf: grillaSolicitudState.prestacionesSolicitud[i].PROF_CCOD,
      TipoAtencion: gruposReajuste[i].tipoAtencion,
      CentroAtencion: gruposReajuste[i].secuencia,
      Arancel: gruposReajuste[i].rutArancel,
    });
  }
  fetch(`${apiConfig.apiUri}/v1/solicitudes/ExisteDetalleSolicitudEnCursoAWReajuste/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    trace.information("ValidarPrestacionesSolicitudEnCurso", result);
    if (result.length > 0) {
      // dispatch(SetSolicitudesEnCurso(true));
      if (reajustePQ.length === 0) {
        dispatch(LoadingValidacion(false));
      }
      dispatch(CargarSolicitudesEnCurso(result));
      if (callbackError) { callbackError(result); }
    } else {
      // dispatch(SetSolicitudesEnCurso(false));
      if (reajustePQ.length === 0) {
        dispatch(LoadingValidacion(false));
      }
      dispatch(Loading(false));
      if (callbackSuccess) { callbackSuccess(); }
    }
  }), (error) => {
    trace.error("ValidarPrestacionesSolicitudEnCurso", error);
  });
};

export const PermiteReplicarSolicitud = () => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutUsuario: globalState.rutUsuario,
    RutPrestador: globalState.rutPrestador,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/solicitudes/PermiteReplicarSolicitud/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("PermiteReplicarSolicitud", result);
    dispatch(SetValidacionReplicacionSolicitud(result.PrestadorPuedeReplicar, result.UsuarioPuedeReplicar));
  }), (error) => {
    trace.error("PermiteReplicarSolicitud", error);
    dispatch(ErrorSnacktOpen(
      "Error al validar replicacion de solicitud:",
      error,
    ));
  });
};

export const IniciarValidacionesReplicacionSolicitud = () => (dispatch) => {
  const globalState = store.getState().global;
  const combinacionesgrupos = store.getState().solicitudReajuste.itemsSolicitudReajuste;
  // const isapre = globalState.isapre; // === "B" ? "T" : "B";
  const isapreReplicar = globalState.isapre === "B" ? "T" : "B";

  let secuencias = combinacionesgrupos.map((p) => p.secuencia);

  // Distinct
  secuencias = secuencias.filter((v, i, a) => a.indexOf(v) === i);


  // Validar Centros de Atencion

  if (secuencias.length > 0) {
    for (let i = 0; i < secuencias.length; i += 1) {
      dispatch(SetDetalleValidacionCentrosAtencion(secuencias[i]));
    }
    for (let i = 0; i < secuencias.length; i += 1) {
      dispatch(validaCentroAtencion(
        globalState.isapre, secuencias[i],
        () => dispatch(ValidarPrestacionesSolicitudEnCurso(isapreReplicar)),
        () => dispatch(SetLoadingValidacionSolicitudEnCurso(false))
      ));
    }
  } else {
    dispatch(LoadingValidacion(false));
    dispatch(SetLoadingValidacionCentrosAtencion(true));
  }
};

export const validaCentroAtencion = (isapre, secuencia, callbackSuccess, callbackError) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Secuencia: secuencia,
    Isapre: isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/centroatencion/SecuenciaHomologacion/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      //trace.information("validaCentroAtencion", json);
      let secuenciaExiste = false;
      if (json && json.Existe && json.Existe === true) {
        secuenciaExiste = true;
      }
      if (secuenciaExiste) {
        dispatch(SetDetalleValidacionCentrosAtencion(secuencia, true, json.Secuencia));
      } else {
        dispatch(SetDetalleValidacionCentrosAtencion(secuencia, false));
      }

      const replicarSolicitudState = store.getState().replicarSolicitud;
      // Si se recorrieron todos las otras validaciones
      if (replicarSolicitudState.detalleValidacionCentrosAtencion
        .filter((c) => c.valido == null).length === 0) {
        const todosCentrosAtencionValidos = replicarSolicitudState.detalleValidacionCentrosAtencion
          .filter((c) => c.valido === false).length === 0;
        dispatch(SetLoadingValidacionCentrosAtencion(todosCentrosAtencionValidos));

        if (todosCentrosAtencionValidos) {
          callbackSuccess();
        } else {
          dispatch(LoadingValidacion(false));
          callbackError();
        }
      }
    })
    .catch((error) => {
      dispatch(LoadingValidacion(false));
      trace.error("validaCentroAtencion", error);
      dispatch(ErrorSnacktOpen(
        "Error al validar centros de atencion:",
        error,
      ));
    });
};

export const ValidarPrestacionesSolicitudEnCurso = (isapreReplicar) => (dispatch) => {
  const globalState = store.getState().global;
  const combinacionesgrupos = store.getState().solicitudReajuste.itemsSolicitudReajuste;
  const solicitudReajusteState = store.getState().solicitudReajuste;
  const reajustePQ = store.getState().solicitudReajuste.itemsSolicitudReajustePQ;


  const secuenciasHomologas = solicitudReajusteState.detalleValidacionCentrosAtencion;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: isapreReplicar,
    Prestaciones: [],
    token: globalState.token,
  };
  for (let i = 0; i < combinacionesgrupos.length; i += 1) {
    const secHomologa = secuenciasHomologas.filter((s) => s.secuencia === combinacionesgrupos[i].secuencia);
    const secHomologaValor = secHomologa && secHomologa.length > 0 ? secHomologa[0].secuenciaHomologo : null;
    params.Prestaciones.push({
      Grupo: combinacionesgrupos[i].idTipoPrestacion,
      TipoAtencion: combinacionesgrupos[i].tipoAtencion,
      CentroAtencion: secHomologaValor,
      Arancel: combinacionesgrupos[i].rutArancel,
    });
  }
  fetch(`${apiConfig.apiUri}/v1/solicitudes/ExisteDetalleSolicitudEnCursoAWReajuste/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("ValidarPrestacionesSolicitudEnCurso", result);
    if (result.length > 0) {
      dispatch(CargarSolicitudesEnCursoReplicaArancel(result));
      dispatch(SetLoadingValidacionSolicitudEnCurso(false));
      if (reajustePQ.length === 0) {
        dispatch(LoadingValidacion(false));
        dispatch(SetLoadingValidacionSolicitudEnCurso(false));
      }
    } else {
      if (reajustePQ.length === 0) {
        dispatch(LoadingValidacion(false));
        dispatch(SetLoadingValidacionSolicitudEnCurso(true));
      }
    }
  }), (error) => {
    dispatch(LoadingValidacion(false));
    trace.error("ValidarPrestacionesSolicitudEnCurso", error);
  });
};

export const ObtenerVigenciasPaquetes = () => (dispatch) => {
  const globalState = store.getState().global;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/reajustes/consultarVigenciaPaquetes/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        if (json.length > 0) {
          dispatch(CargarPaqueteVigencia(json));
          //dispatch(ObtenerTiposPrestacion(json[0].Secuencia));
        }
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerVigenciasPaquetes", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener las vigencias de los paquetes quirúrgicos",
        error,
      ));
    });
};

export const ValidarGruposSolicitudEnCursoPQ = (callbackSuccess, callbackError) => (dispatch) => {
  const globalState = store.getState().global;
  const gruposReajuste = store.getState().solicitudReajuste.itemsSolicitudReajustePQ;
  const reajusteArancel = store.getState().solicitudReajuste.itemsSolicitudReajuste;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    Paquetes: [],
    token: globalState.token,
  };
  for (let i = 0; i < gruposReajuste.length; i += 1) {
    params.Paquetes.push({
      Vigencia: gruposReajuste[i].vigencias,
      Arancel: gruposReajuste[i].rutArancel,
    });
  }
  fetch(`${apiConfig.apiUri}/v1/solicitudes/ExisteDetalleSolicitudEnCursoPQ/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    trace.information("ValidarPrestacionesSolicitudEnCursoPQ", result);
    if (result.length > 0) {
      if (reajusteArancel.length === 0) {
        dispatch(LoadingValidacion(false));
      } else {
        setTimeout(() => dispatch(LoadingValidacion(false)), 30000);
      }
      // dispatch(SetSolicitudesEnCurso(true));
      dispatch(CargarSolicitudesEnCurso(result));
      if (callbackError) { callbackError(result); }
    } else {
      // dispatch(SetSolicitudesEnCurso(false));
      dispatch(Loading(false));
      if (reajusteArancel.length === 0) {
        dispatch(LoadingValidacion(false));
      } else {
        setTimeout(() => dispatch(LoadingValidacion(false)), 30000);
      }
      if (callbackSuccess) { callbackSuccess(); }
    }
  }), (error) => {
    trace.error("ValidarPrestacionesSolicitudEnCursoPQ", error);
  });
};

export const IniciarValidacionesReplicacionSolicitudPQ = () => (dispatch) => {
  const globalState = store.getState().global;
  const isapreReplicar = globalState.isapre === "B" ? "T" : "B";
  const gruposReajuste = store.getState().solicitudReajuste.itemsSolicitudReajustePQ;
  const reajusteArancel = store.getState().solicitudReajuste.itemsSolicitudReajuste;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: isapreReplicar,
    Paquetes: [],
    token: globalState.token,
  };
  for (let i = 0; i < gruposReajuste.length; i += 1) {
    params.Paquetes.push({
      Vigencia: gruposReajuste[i].vigencias,
      Arancel: gruposReajuste[i].rutArancel,
    });
  }

  fetch(`${apiConfig.apiUri}/v1/solicitudes/ExisteVigenciaReplicaPQ/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    trace.information("ExisteVigenciaReplicaPQ", result);
    if (result.length > 0) {
      if (reajusteArancel.length === 0) {
        dispatch(LoadingValidacion(false));
      } else {
        setTimeout(() => dispatch(LoadingValidacion(false)), 30000);
      }
      dispatch(CargarVigenciasNoExistentesReplica(result));
      dispatch(SetLoadingValidacionSolicitudEnCurso(false));
    } else {
      if (reajusteArancel.length === 0) {
        dispatch(LoadingValidacion(false));
      } else {
        dispatch(ValidarGruposSolicitudEnCursoPQR(isapreReplicar));
        //setTimeout(() => dispatch(LoadingValidacion(false)), 30000);
        //setTimeout(() => dispatch(SetLoadingValidacionSolicitudEnCurso(true)), 30000);
      }

    }
  }), (error) => {
    dispatch(LoadingValidacion(false));
    trace.error("ExisteVigenciaReplicaPQ", error);
  });
};

export const ValidarGruposSolicitudEnCursoPQR = (isapreReplicar) => (dispatch) => {
  const globalState = store.getState().global;
  const gruposReajuste = store.getState().solicitudReajuste.itemsSolicitudReajustePQ;
  const reajusteArancel = store.getState().solicitudReajuste.itemsSolicitudReajuste;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: isapreReplicar,
    Paquetes: [],
    token: globalState.token,
  };
  for (let i = 0; i < gruposReajuste.length; i += 1) {
    params.Paquetes.push({
      Vigencia: gruposReajuste[i].vigencias,
      Arancel: gruposReajuste[i].rutArancel,
    });
  }
  fetch(`${apiConfig.apiUri}/v1/solicitudes/ExisteDetalleSolicitudEnCursoPQ/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    trace.information("ValidarPrestacionesSolicitudEnCursoPQR", result);
    if (result.length > 0) {
      if (reajusteArancel.length === 0) {
        dispatch(LoadingValidacion(false));
      } else {
        setTimeout(() => dispatch(LoadingValidacion(false)), 30000);
      }
      // dispatch(SetSolicitudesEnCurso(true));
      dispatch(CargarSolicitudesEnCursoReplicaArancel(result));
      //dispatch(CargarSolicitudesEnCurso(result));
    } else {
      // dispatch(SetSolicitudesEnCurso(false));
      dispatch(Loading(false));
      if (reajusteArancel.length === 0) {
        dispatch(LoadingValidacion(false));
      } else {
        setTimeout(() => dispatch(LoadingValidacion(false)), 30000);
      }
    }
  }), (error) => {
    trace.error("ValidarPrestacionesSolicitudEnCursoPQR", error);
  });
};


// WEBPACK FOOTER //
// ./src/components/ReajustarArancel/SolicitudReajuste/actions.js